import { createSelector } from 'reselect';

export const siteGroupWeatherConfigurationSelector = state => state.entities.siteGroupWeatherConfigurations;

export const getWeatherConfigurationToSiteGroupMapping = createSelector(
  siteGroupWeatherConfigurationSelector,
  configurations => configurations.mapKeys((key, value) => value.get('site_group') + ''),
);

export const selectSiteGroupWeatherConfigurationById = createSelector(
  [siteGroupWeatherConfigurationSelector, (state, id) => id],
  (configurations, id) => {
    const configuration = configurations.get(id + '');
    if (!configuration) {
      return null;
    }
    return configuration.toJS();
  },
);

export const selectSiteGroupWeatherConfigurationBySiteGroupId = createSelector(
  [siteGroupWeatherConfigurationSelector, (state, siteGroupId) => siteGroupId],
  (configurations, siteGroupId) => {
    const configuration = configurations.find(config => config.get('site_group') == siteGroupId);
    if (!configuration) {
      return null;
    }
    return configuration.toJS();
  },
);
